import React from 'react'
import PropTypes from 'prop-types'
import Delete from '@mui/icons-material/Delete'

const DeleteIcon = ({ height, width, ...more }) => {
	
	return (
		<Delete
			height={height}
			width={width}
			{...more}
		/>
	)
}

DeleteIcon.propTypes = {
	height: PropTypes.number.isRequired,
	width: PropTypes.number.isRequired
}

export default DeleteIcon
